import { combineReducers } from 'redux';
import { reducer as config } from '../infrastructure/config';
import { reducer as content } from '../infrastructure/content';
import { reducer as customers } from '../infrastructure/customers';
import { reducer as loader } from '../infrastructure/loader';
import { reducer as dataCapture } from './dataCapture';
import { reducer as offers } from '../infrastructure/offers';
import { reducer as address } from '../infrastructure/address';
import { reducer as officer } from '../infrastructure/officer';
import { reducer as oldSignatories } from '../infrastructure/oldSignatories';
import { reducer as cases } from '../infrastructure/cases';
import { connectRouter } from 'connected-react-router';
import { history } from '../routes/index';

export default combineReducers({
  config,
  content,
  customers,
  loader,
  dataCapture,
  offers,
  address,
  officer,
  cases,
  oldSignatories,
  router: connectRouter(history)
});
